import React, { useEffect, useState } from 'react'

import axios from 'axios'
import { Modal } from 'react-bootstrap'

interface Centre {
  authors: string
  doi: string
  doiUrl: string
  name: string
  title: string
}

interface Publication {
  authors: string
  citationText: string
  doi: string
  doiUrl: string
  title: string
  type: string
  year?: number
}

interface CitationItem {
  centre: Centre
  centrePublicationRelationship: string
  citationSource: string
  publication: Publication
}

interface CitationMeta {
  currentPage: number
  pages: number
  next?: string
  prev?: string
  totalCitations: number
}

interface CitationData {
  data: CitationItem[]
  metadata: CitationMeta
}

export const Citations = ({ uuid }: {uuid: string}) => {
  const [citationCount, setCitationCount] = useState<number>()
  const [citationData, setCitationData] = useState<CitationData>()
  const [citationError, setCitationError] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const loadCount = async () => {
    setCitationCount(undefined)
    setCitationData(undefined)
    setCitationError(false)
    try {
      const resp = await axios.get(`${process.env.REACT_APP_WEB_HOST}/eds-citation/doi/10.5285/${uuid}/count`)
      setCitationCount(resp.data.count)
    } catch (ex: any) {
      if (ex.response.status === 404) {
        setCitationCount(0)
      } else {
        setCitationError(true)
      }
    }
  }

  useEffect(() => {
    loadCount()
  }, [uuid])

  useEffect(() => {
    if (showModal && !citationData) {
      axios.get(`${process.env.REACT_APP_WEB_HOST}/eds-citation/doi/10.5285/${uuid}?page_size=${citationCount}`)
        .then(resp => {
          setCitationData(resp.data)
        })
        .catch(ex => {
          setCitationError(true)
        })
    }
  }, [showModal, citationData, citationCount])

  if (citationError) {
    return (
      <button disabled className='reference-text' style={{ marginBottom: '0.5em' }}>
        Unable to load citations
      </button>
    )
  }

  if (citationCount === undefined) {
    return (
      <button disabled className='reference-text' style={{ marginBottom: '0.5em' }}>
        Loading citations
      </button>
    )
  }

  return (
    <>
      {showModal &&
        <Modal show size='xl' centered scrollable onHide={() => setShowModal(false)} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>{citationCount} Citations</Modal.Title>
          </Modal.Header>
          {citationError
            ? <Modal.Body>Error loading citation data</Modal.Body>
            : <Modal.Body>
                {citationData
                  ? <div style={{ maxHeight: '500px' }}>
                      <table id='citations-table' className='table1'>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Citation Text</th>
                          </tr>
                        </thead>
                        <tbody>
                          {citationData.data.map((citation, i) =>
                            <tr key={i}>
                              <td>
                                <a href={`https://${citation.publication.doiUrl}`} target='_blank' rel='noreferrer'>
                                  {citation.publication.title}
                                </a>
                              </td>
                              <td>{citation.publication.citationText}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  : <div>Loading...</div>
                }
              </Modal.Body>
          }
          <Modal.Footer>
            <button className='styledButton' onClick={() => setShowModal(false)}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      }
      <button disabled={!citationCount} className='reference-text' style={{ marginBottom: '0.5em' }} onClick={() => setShowModal(true)}>
        {citationCount} citations
      </button>
    </>
  )
}
